import { create } from 'evx';
import 'element-closest';
import Queue from './lib/Queue';
import Helpers from './lib/Helpers';
const { detect } = require('detect-browser');

import LazyLoad from './components/LazyLoad';
import SlideToggleGroup from './components/SlideToggleGroup'
import BundleBuilder from './components/BundleBuilder'
import ClassChange from './components/ClassChange';
import Marquee from './components/Marquee';
import Tabs from './components/Tabs';
import AddToCart from './components/AddToCart'
import Cart from './components/Cart'
import SideCart from './components/SideCart'
import ImageWithZoom from './components/ImageWithZoom';
import Product from './components/Product'
import KeenSlider from './components/KeenSlider';
import DeliveryDate from './components/DeliveryDate';
import Klaviyo from './components/Klaviyo';
import LoadMoreComp from './components/LoadMore';

const components = {
    'bundle-builder': BundleBuilder,
    'image-with-zoom': ImageWithZoom,
    'lazy-load': LazyLoad,
    'toggle-group': SlideToggleGroup,
    'class-change': ClassChange,
    'marquee': Marquee,
    'tabs': Tabs,
    'add-to-cart': AddToCart,
    'cart': Cart,
    'side-cart': SideCart,
    'keen-slider': KeenSlider,  
    'product': Product,
    'delivery-date': DeliveryDate,
    'klaviyo': Klaviyo,
    'load-more-comp': LoadMoreComp
};

const options = {
    turbolinks: false,
};

const state = {
    eventQueue: new Queue(),
    ajaxCache: [],
};

export default class Theme {
    constructor(ctx = state, passedOptions = {}) {
        this._options = { ...passedOptions, ...options };
        let themeInfoElem = document.querySelector('[data-theme-information]');
        if (themeInfoElem) {
            ctx = { ...ctx, ...JSON.parse(themeInfoElem.innerHTML) };
        }
        this._ctx = create(ctx);
        this._viewportEvent();
        this._bodyScrollListen();
        this._runHooks();
        this._browserDetect();
        this._components = [];
    }

    _browserDetect() {
        const browser = detect();
        if (browser) {
            document.body.classList.add(
                `browser--${Helpers.handleize(browser.name)}`
            );
            document.body.classList.add(`os--${Helpers.handleize(browser.os)}`);
        }
    }

    _viewportEvent() {
        window.addEventListener(
            'resize',
            () => {
                this._viewportLogic();
            },
            { passive: true }
        );
        this._viewportLogic();
    }

    _bodyScrollListen() {
        const targetNode = document.body;
        const config = { attributes: true, childList: false, subtree: false };

        const callback = function (mutationsList, observer) {
            document.documentElement.style.setProperty(
                '--scroll-gap-right',
                getComputedStyle(document.body).paddingRight
            );
        };

        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
    }

    _viewportLogic() {
        let vh = window.innerHeight * 0.01;
        let vw = document.body.clientWidth * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        document.documentElement.style.setProperty('--vw', `${vw}px`);
    }

    mountComponents(container = document) {
        for (let componentKey in components) {
            if (components.hasOwnProperty(componentKey)) {
                let selector = `[data-${componentKey}]`;
                let elements = container.querySelectorAll(selector);
                for (let elem of elements) {
                    this.mountComponent(componentKey, componentKey, elem);
                }
            }
        }
        window.__Theme = this;
        window.__ThemeComponents = this._components;

        this._ctx.emit('mounted');
    }

    unmountComponents(container = document) {
        for (var i = this._components.length - 1; i >= 0; i--) {
            let component = this._components[i];

            if (container.contains(component.elem)) {
                let componentObj = component.component;
                if (typeof componentObj.unmount === 'function') {
                    componentObj.unmount();
                }
                component = null;
                componentObj = null;
                this._components.splice(i, 1);
            }
        }
    }

    mountComponent(type, dataAttr, elem) {
        let optionStr = elem.getAttribute(`data-${dataAttr}`).trim();
        let options = {};
        if (optionStr.startsWith('{') || optionStr.startsWith('[')) {
            options = JSON.parse(optionStr);
        }
        let compInstance = new components[type](elem, this, options, this._ctx);
        this._components.push({
            type: type,
            elem: elem,
            id: compInstance._options.id,
            component: compInstance,
        });

        try {
            compInstance.mount();
        } catch (e) {
            console.error(
                `-----ERROR IN COMPONENT----- \ntype: ${type}\nelement and stack trace below:`
            );
            console.error(elem);
            console.error(e);
        }
    }

    getOptions() {
        return this._options;
    }

    getComponent(id) {
        return this._components.find((component) => component.id === id);
    }

    getComponentByElem(elem) {
        return this._components.find((component) => component.elem === elem);
    }

    _runHooks() {
        this._ctx.on('cart-item-added', (state) => {
            if (window.pintrk) {
                pintrk('track', 'addtocart', {
                    value: state.lastItemAdded.item.price / 100.0,
                    order_quantity: state.lastItemAdded.quantity,
                });
            }
            if (window.fbq) {
                fbq('track', 'AddToCart');
            }
        });
    }
}
